/** ***********************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 ************************************************************************* */

import { observable, action } from 'mobx';

// Details on properties captured in wiki page: https://wiki.corp.adobe.com/display/ccd/App+PDP+Model
export default class PDP {
    /*
     List of Actions specific to pdp. Actions have following properties:
     - actionId
     - actionType
     */
    @observable applicableActionList;

    @observable app; // App type of object

    /**
     * Callback to be executed when any action taken on the PDP
     * @type {function}
     */
    actionHandlerCallback;

    /**
     * Config for supportedBannerVideoFormats and allowed domains
     */
    bannerConfig;

    /**
     * Data from contentful used to display static content
     */
    contentfulData;

    /**
     * Locale in which translation strings are to be rendered.
     */
    locale;

    /**
     * BasePath of assets used in pdp in fileSystem (CCD Only)
     */
    localAssetsBasePath;

    @action setApp(app) {
        this.app = app;
    }

    @action setApplicableActionList(applicableActionList) {
        this.applicableActionList = applicableActionList;
    }

    constructor({
        applicableActionList, app, actionHandlerCallback, contentfulData,
        bannerConfig, locale, localAssetsBasePath,
    }) {
        this.applicableActionList = applicableActionList;
        this.app = app;
        this.actionHandlerCallback = actionHandlerCallback;
        this.contentfulData = contentfulData;
        this.bannerConfig = bannerConfig;
        this.locale = locale;
        this.localAssetsBasePath = localAssetsBasePath;
    }
}
